import { Button, Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { adwResetFields } from "../../dataWranglerSlice";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { colours } from "../../../../StyleConstants";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

interface Props {
    setOpenLoadQueryModal: (arg0: boolean) => void,
    resetGridFilterSettings: () => void,
    downloadDataDictionary: () => void
}

const ADWToolbar = (props: Props) => {
    const { setOpenLoadQueryModal, resetGridFilterSettings, downloadDataDictionary } = props;

    const dispatch = useDispatch();
    const resetFields = () => {
        dispatch(adwResetFields());
        resetGridFilterSettings();
    }

    return (
        <>
            <Stack
                direction="row"
                justifyContent={'space-between'}
                alignItems="center"
                flexGrow={1}
                mb={0}
                gap={3}
            >
                <Stack
                    direction="row"
                    gap={3}
                    alignItems="center"
                >
                    <Button
                        variant="outlined"
                        onClick={resetFields}
                        color="error"
                        size={"small"}
                        sx={{
                            color: colours.error.error,
                            borderColor: colours.error.error
                        }}
                    >
                        Reset Query
                    </Button>
                    <Button
                        variant="tertiary"
                        startIcon={<SaveOutlinedIcon/>}
                        size={"small"}
                        onClick={() => setOpenLoadQueryModal(true)}
                        aria-haspopup={true}
                    >
                        Load Query
                    </Button>
                    <Button
                        variant="secondary"
                        startIcon={<ArrowCircleDownIcon/>}
                        size={"small"}
                        onClick={() => downloadDataDictionary()}
                        aria-haspopup={true}
                    >
                        Download
                    </Button>
                </Stack>
            </Stack>
        </>
    )
}

export default ADWToolbar;